import React from "react";
import { Image } from "../elements/bodyComponents";
//import FacebookProvider, { ShareButton } from 'react-facebook';
import {
  FacebookShareButton,
  TwitterShareButton,
  PinterestShareButton
} from "react-share";

//data
import { Config } from "../json/config";

/*
    Social Share
*/
export class SocialShare extends React.Component {
  render() {
    let socialItems = Config.social.map((s, index) => (
      <SocialItem
        key={s.network}
        order={index}
        data={s}
        image={this.props.image}
        title={this.props.title}
        desc={this.props.desc}
      />
    ));

    return (
      <div
        className={`social-wrap ${
          typeof this.props.classes !== "undefined" ? this.props.classes : ""
        }`}
        data-color={this.props.color}
      >
        <div className="flex">{socialItems}</div>
        <p className="social-shareText uppercase">Share</p>
      </div>
    );
  }
}

class SocialItem extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler() {
    const s = this.props.data;
    const top = window.innerHeight * 0.5 - Config.socialWindow.height / 2;
    const left = window.innerWidth * 0.5 - Config.socialWindow.width / 2;
    if (s.network === "facebook") {
      return false;
    }
    let dataMap = null;
    let dataReg = null;

    if (s.network === "pinterest") {
      //generate the URL
      dataMap = {
        "{{ shareURL }}": window.location.href,
        "{{ image }}": window.location.origin + this.props.image,
        "{{ description }}": `${this.props.title}`
      };
      dataReg = new RegExp(Object.keys(dataMap).join("|"), "gi");
      const href = s.baseURL.replace(dataReg, function(matched) {
        return dataMap[matched];
      });

      window.open(
        href,
        "Share recipe",
        "height=" +
          Config.socialWindow.height +
          ",width=" +
          Config.socialWindow.width +
          ",left=" +
          left +
          ",top=" +
          top +
          ",screenX=" +
          left +
          ",screenY=" +
          top
      );
    }

    if (s.network === "twitter") {
      //generate the URL
      dataMap = {
        "{{ shareURL }}": window.location.href,
        "{{ description }}": `${this.props.title}`
      };
      dataReg = new RegExp(Object.keys(dataMap).join("|"), "gi");
      const href = s.baseURL.replace(dataReg, function(matched) {
        return dataMap[matched];
      });

      window.open(
        href,
        "Share recipe",
        "height=" +
          Config.socialWindow.height +
          ",width=" +
          Config.socialWindow.width +
          ",left=" +
          left +
          ",top=" +
          top +
          ",screenX=" +
          left +
          ",screenY=" +
          top
      );
    }
  }

  render() {
    const s = this.props.data;

    return (
      <div
        id={s.network}
        className={`social-item ${
          typeof s.classes !== "undefined" ? s.classes : ""
        }`}
        onClick={this.clickHandler}
        data-analytics-type="customlink"
        data-module="social share"
        data-title={s.network}
        data-position={this.props.order}
        data-targeturl={s.networkURL}
        data-locurl={window.location.href}
      >
        {s.network === "facebook" && (
          <FacebookShareButton
            url={window.location.href}
            quote={this.props.title}
          />
        )}
        {s.id !== "facebook" && (
          <Image src={s.icon} classes="social-icon" alt={s.id} />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/social/components.js